export default "__VITE_ASSET__B0q372DN__"